// extracted by mini-css-extract-plugin
module.exports = {"Title":"Quotations__Title_jsBwr"};